/**
 * @function downloadImageFromUrl
 *
 * @description Downloads an image straight from S3 with a direct fetch.
 *
 * `cache: 'no-store'` is required: the same image is already shown with an
 * <img> (a request without `Origin`), and S3 answers that one without
 * `Access-Control-Allow-Origin` and without `Vary: Origin`. If the fetch reused
 * that cached response the browser would block it as a CORS error, even though
 * the bucket does have CORS configured.
 *
 * It does NOT go through /download-file-and-convert-to-base64 on purpose: that
 * endpoint accepts any URL with no authentication (SSRF).
 *
 * @param {string} url - The URL of the image
 * @param {string} filename - The name of the downloaded file
 * @returns {Promise<void>}
 * @throws {Error} - If the request fails or the response is not OK
 */
export const downloadImageFromUrl = async (url, filename) => {
  if (!url) throw new Error('Missing image URL');

  const response = await fetch(url, { method: 'GET', cache: 'no-store' });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};



// WEBPACK FOOTER //
// src/lib/images/downloadImage.js